import { Component, OnInit, Output } from '@angular/core';
import { routerTransition } from './../../shared/animations/router.animations';
import { Subscription } from 'rxjs';
import { FilesService } from './../../shared/services/files.service';

@Component({
  selector: 'swb-layout',
  templateUrl: './layout.component.html',
  animations: [routerTransition]
})
export class LayoutComponent implements OnInit {
  private _subscription: Subscription;

  @Output()
  public browseConfig: any;

  constructor(
    private _filesService: FilesService
  ) { }

  ngOnInit() {
    this._subscription = this._filesService.browserToggled$.subscribe((browseConfig: any) => {
      this.browseConfig = browseConfig;
    });
  }

  public getState(outlet): string {
    return outlet.activatedRouteData.state;
  }

}
